import { FormItem, Textarea } from '@vkontakte/vkui';
import React from 'react';
import PropTypes from 'prop-types';
import { prepareString } from '../../../helpers/helpers';

export const CommentInputComponent = ({error, setError, comment, setComment, label, errorTextMaxLength}) => {
  return (<FormItem
    top={label}
    status={error.length > 0 ? 'error' : ''}
    bottom={error}
  >
    <Textarea
      maxLength={255}
      value={comment}
      onChange={(event) => setComment(event.target.value)}
      onBlur={() => {
        setComment(prepareString(comment));
        setError([...prepareString(comment)].length > 255 ? errorTextMaxLength : '');
      }}
      rows={2}
    />
  </FormItem>);
}

CommentInputComponent.propTypes = {
  error: PropTypes.string.isRequired,
  setError: PropTypes.func.isRequired,
  comment: PropTypes.string.isRequired,
  setComment: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  errorTextMaxLength: PropTypes.string.isRequired,
};
